import React, { FC } from "react";

import styles from "./styles.module.scss";

export interface DataFieldProps {}

export const DataField: FC<DataFieldProps> = ({ children }) => {
  return <div className={styles.dataFieldContainer}>{children}</div>;
};
